import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/video/5s-reel.mp4")